import { Component, OnInit, ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SettingService } from '../../../services/setting.service';
import { AdminService } from '../../admin.service';
import { Setting } from '../../../models/setting.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-white-black-listing',
  templateUrl: './white-black-listing.component.html',
  styleUrls: ['./white-black-listing.component.css']
})
export class WhiteBlackListingComponent implements OnInit, OnDestroy {
  loading = false;
  setting: Setting;
  settings: Setting[] = [];

  settingWhiteListOfficeIDForm: FormGroup;
  settingBlackListBrandIDForm: FormGroup;

  subscription: Subscription;
  subscriptionResponse: Subscription;

  @ViewChild('settingWhiteListOfficeIDModalClose') settingWhiteListOfficeIDModalClose: ElementRef;
  @ViewChild('settingBlackListBrandIDModalClose') settingBlackListBrandIDModalClose: ElementRef;

  constructor(private adminService: AdminService,
    private settingService: SettingService,
    private route: ActivatedRoute,
    private router: Router) { }

  ngOnInit() {
    this.loading = true;
    this.subscription = this.settingService.settingChanged.subscribe(
      (setting: Setting) => {
        if (typeof setting !== 'undefined') {
          this.loading = false;
          this.setting = setting;

          this.editForm();
        }
      }
    );

    this.subscriptionResponse = this.settingService.settingOperation.subscribe(
      (setting: Setting) => {
        if ( typeof setting.ID !== 'undefined' ) {
          this.loading = true;
          this.settingService.httpGetSetting(1);
        }
      }
    );

    this.initForm();

    this.settingService.httpGetSetting(1);
  }

  private initForm() {
    this.settingWhiteListOfficeIDForm = new FormGroup({
      'whitelist_officeid': new FormControl('')
    });

    this.settingBlackListBrandIDForm = new FormGroup({
      'blacklist_brandid': new FormControl('')
    });
  }

  private editForm() {
    this.settingWhiteListOfficeIDForm.patchValue({
      'whitelist_officeid': this.setting.whitelist_officeid
    });

    this.settingBlackListBrandIDForm.patchValue({
      'blacklist_brandid': this.setting.blacklist_brandid
    });
  }

  onSubmit(type) {
    if (this.settingWhiteListOfficeIDForm.valid || this.settingBlackListBrandIDForm.valid) {
      this.loading = true;

      let settingValues: Setting;
      if (type === 'whitelist_officeid') {
        settingValues = this.settingWhiteListOfficeIDForm.value;
      } else {
        settingValues = this.settingBlackListBrandIDForm.value;
      }

      this.settingService.httpPutSetting(1, settingValues);

      setTimeout(
        () => {
          this.settingWhiteListOfficeIDModalClose.nativeElement.click();
          this.settingBlackListBrandIDModalClose.nativeElement.click();
        }, 200
      );
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionResponse.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/setting-admin/white-black-listing/white-black-listing.component.ts